"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Menu {
}
exports.default = Menu;
//# sourceMappingURL=Menu.js.map